import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ActivatedRoute } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AuthService } from 'common/services/auth.service';
import { IRequest } from 'app/shared/Domains/request';
import { IUser } from 'app/shared/Domains/IUser';
import { Configuration } from 'config/config';
import { ExportDataComponent } from 'app/members/components/export-data/export-data.component';
import { LanguageService } from 'app/LanguageService/Language.Service';


@Component({
  selector: 'app-activity-logs',
  templateUrl: './activity-logs.component.html',
  styleUrls: ['./activity-logs.component.css']
})
export class ActivityLogsComponent implements OnInit {

  requests: any[] = [];
  groupedRequests: { [key: string]: IRequest[] } = {};
  soureRequstors: IRequest[] = [];
  userRole: IUser;
  searchValue: any;
  loading: boolean = false;
  activityTypeOptions: any[] = [];
  activityByOptions: any[] = [];
  activityTypeValue: any = 'All'
  activityByValue: any = 'All'
  filteredRequests: IRequest[];
  from: any;
  to: any;
  user: IUser;
  populated: boolean = false;

  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("ActivityLogsComponent", label);
  }

  constructor(private LanguageService: LanguageService, private route: ActivatedRoute, public config: Configuration, private ConfirmationService: ConfirmationService, private messageService: MessageService, private breadcrumbService: BreadcrumbService, private appServiceManager: AppServiceManager, private exportDataComponent: ExportDataComponent,) {
    this.breadcrumbService.setItems([
      { label: 'Activity Logs' }
    ]);
    this.LanguageService = LanguageService;
  }

  ngOnInit() {
    this.userRole = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    var date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), 1);
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.from.setHours(0, 0, 0, 0);
    this.to.setHours(23, 59, 59, 999);
    this.resetFilter();
    if(this.userRole.name =="Admin" ||  this.userRole.name =="Super Admin" )
    {
      this.activityByValue="All";
    }
    else{
      this.activityByValue=this.user.name;
    }
    this.getActivityLogs();
    this.activityTypeOptions = [{ label: "All", value: 'All' }, { label: "Add Fee", value: 'Add Fee' }, { label: "Activate", value: 'Activate' }, { label: "Deactivate", value: 'Deactivate' },
    { label: "DeFreeze", value: 'DeFreeze' }, { label: "Delete Fee", value: 'Delete Fee' }, { label: "Freeze", value: 'Freeze' }, { label: "Login", value: 'Login User' },
    { label: "Member Settings", value: 'Member Settings' }, { label: "Update Package", value: 'Update Package' }];
    this.activityByOptions = [{ label: "All", value: 'All' }];
  }

  getActivityLogs() {
    this.loading = true;
    const formatDate = (date: Date) => {
      return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
    };  
    const formattedFrom = formatDate(new Date(this.from));
    const formattedTo = formatDate(new Date(this.to));
    if (this.from <= this.to) {
      const apiUrl = `activityLogs/company/${AuthService.getLoggedInCompany()}/branch/${AuthService.getLoggedInBranch()}?activityType=${this.activityTypeValue}&activityBy=${this.activityByValue}&dateFrom=${formattedFrom}&dateTo=${formattedTo}`;

      this.appServiceManager.get(apiUrl).subscribe(
        (requests) => {
          if (requests.length === 0) {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          }
          this.requests = requests.response;
          this.soureRequstors = requests.response;
          this.filterRequestsByActivity();
          if (!this.populated) {
            this.populateActivityByUsers();
            this.populated = true;
          }
          this.filterRequestsByUsers();
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      );
    } else {
      this.loading = false;
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'From Date is greater than To Date' });
    }
  }
  isExcludedActivityType(activityType: string): boolean {
    // Define a regular expression pattern to match excluded property paths
    const excludedPatterns = [
      /^packageId$/,
      /^customerstrainer\.dueDate$/,
      /^oldDate$/,
      /^oldValue$/,
      /^currentUserData$/,
      /^type$/,
      /^scope$/,
      /^initiatedFrom$/,
      /^memberSettingFlag$/,
      /^modifiedBy$/,
      /^activityBy$/,
      /^attendance(\..*)?$/
  ];
    // Check if the activity type matches any of the excluded patterns
    return excludedPatterns.some(pattern => pattern.test(activityType));
}

  formatOldValues(requestor) {
    let formattedOldValues = '';
    let counter = 1;
    requestor.updatedValues.forEach((updatedValue) => {
      if (!this.isExcludedActivityType(updatedValue.subjectType)) {
        if (formattedOldValues !== '') {
          formattedOldValues += '; ';
        }
        formattedOldValues += `${counter}. ${this.formatValue(updatedValue.oldValue)}`;
        counter++;
      }
    });
    return formattedOldValues;
  }

  formatNewValues(requestor) {
    let formattedNewValues = '';
    let counter = 1;

    requestor.updatedValues.forEach((updatedValue) => {
      // Check if the subjectType is 'profile'
      if (updatedValue.subjectType === 'profile') {
        updatedValue.newValue = 'profile changed';
        updatedValue.oldValue = 'profile changed';
      }

      // Exclude activity types as per existing logic
      if (!this.isExcludedActivityType(updatedValue.subjectType)) {
        if (formattedNewValues !== '') {
          formattedNewValues += '; ';
        }
        // Format and add the updated value
        formattedNewValues += `${counter}. ${this.formatValue(updatedValue.newValue)}`;
        counter++;
      }
    });

    return formattedNewValues;
  }
formatValue(value) {
  if (this.isDate(value)) {
    return new Date(value).toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
  return value;
}

isDate(value) {
  return !isNaN(Date.parse(value));
}

  ExportData(reports, name) {
    this.ConfirmationService.confirm({
      message: "Are you sure you want to Export ?",
      accept: () => {

        const transformedData = reports.map(item => ({
          Activity_Date: new Date(item?.createdDateNow).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
          Activity_Type: item?.activityType,
          Activity_By: item?.activityBy,
          Initiated_From: item?.initiatedFrom,
          Membership_No: item?.entitiyTagNumber,
          Subject: item?.subject,
          Scope: item?.scope,
          Old_Value: item?.oldValue,
          New_Value: item?.newValue,
        }));

        const totalRecords = reports.length;

        const summaryObject = {
          Total_Records: totalRecords,
        };
        //transformedData.push(summaryObject);
        this.exportDataComponent.ExportDataReports(transformedData, summaryObject, name);
      }
    });
    // calling export comp
  }

  populateActivityByUsers() {
    const uniqueActivityByUsers = new Set<string>(); // Specify the type as string
    this.requests.forEach((request) => {
      if (request.activityBy) {
        uniqueActivityByUsers.add(request.activityBy);
      }
    });
    // Convert the Set to an array and sort it alphabetically
    const sortedActivityByUsers = Array.from(uniqueActivityByUsers).sort((a, b) => (a as string).localeCompare(b as string));

    // Add an "All" option at the beginning of the array
    if(this.userRole.name =="Admin" ||  this.userRole.name =="Super Admin" )
    {
      this.activityByOptions = [
        { label: 'All', value: 'All' },
        ...sortedActivityByUsers.map((userName) => ({
          label: userName,
          value: userName,
        }))
      ];
    }
    else{
      this.activityByOptions=[{ label:this.user.name, value:this.user.name}];
      this.activityByValue=this.user.name;
    }
  }

  filterRequestsByActivity() {
    if (this.activityTypeValue === 'All') {
      this.filteredRequests = this.requests;
    } else {
      this.filteredRequests = this.requests.filter(request => request.activityType === this.activityTypeValue);
    }
  }

  filterRequestsByUsers() {
    if (this.activityByValue === 'All') {
      this.filteredRequests = this.requests;
    } else {
      this.filteredRequests = this.requests.filter(request => request.activityBy === this.activityByValue);
    }
  }

  resetFilter() {
    this.searchValue = '';
    this.activityTypeValue = 'All';
    this.activityByValue = 'All';
    var date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), 1);
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.requests = [];
    this.getActivityLogs();
  }

  searchLocal(value) {
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.requests = Object.assign([], this.soureRequstors);
      }
      if (!value) {
        this.requests = Object.assign([], this.soureRequstors);
      }
      if (value != "") {
        const matchedRequest = Object.assign([], this.soureRequstors).filter(
          requestor => requestor.entitiyTagNumber && requestor.entitiyTagNumber.includes(value)
        );

        if (matchedRequest.length === 0) {
          this.requests = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.requests = matchedRequest;
        }
      }
    } else {
      this.requests = Object.assign([], this.soureRequstors);
    }
  }

}
